@let tableData = (tableData$ | async) ?? [];

<div
  class="grid grid-cols-12 purchase-history-tab bg-white rounded-lg border border-[var(--p-border-100)] gap-3 pb-6 mt-3"
>
  <section
    class="col-span-12 purchase-description py-5 px-6 border-b border-[var(--p-border-100)] mb-2"
  >
    <h4 class="text-lg font-semibold text-[var(--p-text-900)]">Histórico</h4>
    <p class="text-sm text-[var(--p-text-700)]">
      Visualize o histórico de compras de cupons
    </p>
  </section>

  <section class="col-span-12 px-6 mb-4 search-section">
    <form [formGroup]="searchForm" class="w-full">
      <div class="relative w-full md:w-96">
        <app-input-icon
          placeholder="Nome ou CPF"
          fullWidth
          formControlName="search"
          class="h-[42px]"
        />
      </div>
    </form>
  </section>

  <section class="col-span-12 px-6">
    <app-table
      #datatable
      [tableData]="tableData"
      [columns]="columns"
      [totalRecords]="tableTotalRecords()"
      [dataKey]="'cpf'"
      [rowsPerPage]="rows"
      [paginate]="true"
      (tableChange)="onTableChange($event)"
      (rowClick)="navigateToDetails($event)"
    />
  </section>
</div>
